import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  awaitContent$default12h4qgz8umrzx as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_awaitContent__vf28kb($this, min, $completion) {
  if ($this.h4j().v2() >= fromInt(min)) {
    return true;
  }
  var tmp = $this.y4k_1.p4j(min, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    transferFromDelegate($this);
    return true;
  }
  return false;
}
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.z4k_1.h4g($this.y4k_1.h4j());
  $this.a4l_1 = add($this.a4l_1, appended);
}
function updateConsumed($this) {
  $this.b4l_1 = add($this.b4l_1, subtract($this.a4l_1, $this.z4k_1.v2()));
  $this.a4l_1 = $this.z4k_1.v2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.y4k_1 = delegate;
        this.z4k_1 = new (Buffer())();
        this.a4l_1 = 0n;
        this.b4l_1 = 0n;
      }
      c4l() {
        updateConsumed(this);
        return this.b4l_1;
      }
      m4j() {
        return this.y4k_1.m4j();
      }
      o4j() {
        return this.z4k_1.z3x() && this.y4k_1.o4j();
      }
      h4j() {
        transferFromDelegate(this);
        return this.z4k_1;
      }
      p4j(min, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_awaitContent__vf28kb.bind(VOID, this, min), $completion);
      }
      s4j(cause) {
        this.y4k_1.s4j(cause);
        this.z4k_1.q6();
      }
    }
    protoOf($).q4j = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
